import React, { useState } from 'react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { isDoneStatus } from '../../utils/progress';
import { Button } from '../ui/Button';
export function SessionReview() {
  const {
    timer,
    myTemplates,
    templateById,
    minutesToday,
    getOcc,
    saveSession,
    discardTimer
  } = useAppState();
  const {
    setTimerSheetOpen
  } = useUi();
  const initialMinutes = timer ? Math.round((timer.finalMs ?? 0) / 60000) : 0;
  const [minutesText, setMinutesText] = useState(String(initialMinutes));
  const [templateId, setTemplateId] = useState<string>(timer?.target.templateId ?? '');
  const [note, setNote] = useState('');
  if (!timer) return null;
  const minutes = Number.parseInt(minutesText, 10);
  const valid = Number.isFinite(minutes) && minutes >= 1 && minutes <= 600;
  const template = templateById(templateId || undefined);
  const total = template ? minutesToday(template.id) + (valid ? minutes : 0) : 0;
  const canCheck = valid && template !== undefined && template.confirmation === 'zaupanje' && template.targetMinutes !== undefined && total >= template.targetMinutes && !isDoneStatus(getOcc(template.id).status);
  const save = (alsoCheck: boolean) => {
    saveSession({
      minutes,
      templateId: template?.id,
      freeLabel: template ? undefined : timer.target.freeLabel,
      note: note.trim() || undefined,
      alsoCheck
    });
    setTimerSheetOpen(false);
  };
  return <div className="space-y-4" data-id="element-1078" data-mp="33ajna1n2x3t4">
      <div data-id="element-1079" data-mp="33bup3vwys1hl">
        <label htmlFor="session-minutes" className="text-sm font-extrabold" data-id="element-1080" data-mp="33bl28h77uag4">
          Trajanje brez premorov
        </label>
        <div className="mt-1.5 flex items-center gap-2" data-id="element-1081" data-mp="3c3my026cb2k2">
          <input id="session-minutes" type="number" inputMode="numeric" min={1} max={600} value={minutesText} onChange={e => setMinutesText(e.target.value)} className="h-12 w-28 rounded-xl border border-line bg-surface px-3 text-lg font-extrabold tabular-nums focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/30" aria-describedby="session-minutes-help" data-id="element-1082" data-mp="3c57q7l56m9er" />
          <span className="font-semibold text-muted" data-id="element-1083" data-mp="i5b8gogn26g">min</span>
        </div>
        <p id="session-minutes-help" className={`mt-1 text-xs ${valid ? 'text-muted' : 'font-semibold text-accent-ink'}`} data-id="element-1084" data-mp="3roq0pvyva21d">
          {valid ? 'Če je trajanje napačno, ga popravi.' : 'Vpiši od 1 do 600 minut.'}
        </p>
      </div>

      <div data-id="element-1085" data-mp="2z257epytzfv6">
        <label htmlFor="session-task" className="text-sm font-extrabold" data-id="element-1086" data-mp="2z2f1aomzy765">
          Povezana naloga
        </label>
        <select id="session-task" value={templateId} onChange={e => setTemplateId(e.target.value)} className="mt-1.5 h-11 w-full rounded-xl border border-line bg-surface px-3 text-sm focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/30" data-id="element-1087" data-mp="38yi0pmqgrrpe">
          <option value="" data-id="element-1088" data-mp="vs1taxephuj4">{timer.target.freeLabel ? `Prosta dejavnost: ${timer.target.freeLabel}` : 'Brez povezave'}</option>
          {myTemplates.map(t => <option key={t.id} value={t.id} data-id="element-1089" data-mp="10osa5myc4u5l">
              {t.title}
            </option>)}
        </select>
        {template?.targetMinutes && <p className="mt-1 text-xs font-semibold tabular-nums text-muted" data-id="element-1090" data-mp="qrw2fjg9gc23">
            Po shranjevanju: {total}/{template.targetMinutes} min danes
          </p>}
        {template?.confirmation === 'skrbnik' && <p className="mt-1 text-xs text-muted" data-id="element-1091" data-mp="1jgtidfx01wro">Opravilo potrdi skrbnik – oddaj ga v pregled posebej.</p>}
      </div>

      <div data-id="element-1092" data-mp="14qm7bl9bng10">
        <label htmlFor="session-note" className="text-sm font-extrabold" data-id="element-1093" data-mp="19rjnxteoo20e">
          Opomba <span className="font-semibold text-muted" data-id="element-1094" data-mp="19p6xeruv0jbq">(neobvezno)</span>
        </label>
        <textarea id="session-note" rows={2} value={note} onChange={e => setNote(e.target.value)} className="mt-1.5 w-full rounded-xl border border-line bg-surface px-3 py-2 text-sm focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/30" data-id="element-1095" data-mp="1xft68lcou7ms" />
      </div>

      <div className="grid gap-2" data-id="element-1096" data-mp="4lcz7585lzk3">
        {canCheck && <Button variant="success" size="lg" onClick={() => save(true)} data-id="element-1097" data-mp="4llfz87edp0k">
            Shrani in obkljukaj nalogo
          </Button>}
        <Button variant={canCheck ? 'secondary' : 'primary'} size="lg" disabled={!valid} onClick={() => save(false)} data-id="element-1098" data-mp="x9r29ze3nm2i">
          Shrani
        </Button>
        <Button variant="ghost" onClick={() => {
        discardTimer();
        setTimerSheetOpen(false);
      }} className="text-accent-ink" data-id="element-1099" data-mp="sbfqhj48v1hn">
          Zavrzi sejo
        </Button>
      </div>
    </div>;
}